
import React, { Component } from 'react';

import "@arco-design/web-react/dist/css/arco.css";
import { Form,Input, Layout, Menu, Space, Card, Carousel,Button,Typography,Modal  } from '@arco-design/web-react';

import * as utils from "../utils.js"
import ScaledImage from '../comp/my-img';
import MyComp from '../comp/my-comp.js';

const MenuItem = Menu.Item;
const SubMenu = Menu.SubMenu;
const FormItem = Form.Item;


export default class App extends MyComp{
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
    }
    this.hasScroll = document.body.scrollHeight > window.innerHeight
  }

  getEntry(idx){
    let {winWidth} = this.state
    if(winWidth == 0){
      return
    }
    let {language} = this.props
    let languageFolder = utils.GetLanguageFolder(language)


    let rate = winWidth/2027
    let height = 915*rate
    let urlbg = `../imgs/img_entry${idx}.png`
    let url_txt1 = `../imgs/${languageFolder}img_entry${idx}_text1.png`
    let url_txt2 = `../imgs/img_entry${idx}_text2.png`
    let dlt = this.hasScroll ? 5 : 0
    dlt = 0

    if(language == 'de' || language == 'en'){
      return (<div style={{position:'relative', width: `calc(50vw - ${dlt}px)`, height: height}} onClick={()=>{
        this.props.history.push({
          pathname:`/page${idx+3}`,
          state: []
        })
      }}>
        <img src={urlbg} style={{width: '100%', height: height, position:'absolute', left: 0, top: 0,}} />
        <Space direction='vertical' style={{ width: '100%', height: height, position:'absolute', left: 0, top: 0, alignItems:'center', justifyContent:'center'}}>
          <ScaledImage src={url_txt1} rate={rate}></ScaledImage>
        </Space>
      </div>
      )
    }
    return (<div style={{position:'relative', width: `calc(50vw - ${dlt}px)`, height: height}} onClick={()=>{
      this.props.history.push({
        pathname:`/page${idx+3}`,
        state: []
      })
    }}>
      <img src={urlbg} style={{width: '100%', height: height, position:'absolute', left: 0, top: 0,}} />
      <Space direction='vertical' style={{ width: '100%', height: height, position:'absolute', left: 0, top: 0, alignItems:'center', justifyContent:'center'}}>
        <ScaledImage src={url_txt1} rate={rate}></ScaledImage>
        <ScaledImage src={url_txt2} rate={rate}></ScaledImage>
      </Space>
    </div>
    )
  }

  getBody(){
    let {winWidth} = this.state
    if(winWidth == 0){
      return
    }
    let rate = winWidth/2027
    let panelHeight = rate*1338
    return (
      <Space size={0} direction='vertical' style={{width: '100vw',padding:0,margin:0,}}>
        <Carousel style={{ width: '100vw', height: panelHeight}}>
          {this.getCompany1()}
          {this.getCompany2()}
          {this.getCompany3()}
        </Carousel>

        {/* <img src='../imgs/img_banner1.png' style={{width:'100vw', aspectRatio:'auto', verticalAlign:'bottom'}} /> */}
        {/* <img src='../imgs/img_banner2_0.png' style={{width:'100vw', aspectRatio:'auto', verticalAlign:'bottom'}} /> */}
        {/* <img src='../imgs/img_banner3_0.png' style={{width:'100vw', aspectRatio:'auto', verticalAlign:'bottom'}} /> */}
        
        <Space direction='horizontal' size={0} style={{width: '100vw',verticalAlign: 'bottom'}}>
          {this.getEntry(1)}
          {this.getEntry(2)}
        </Space>
        <Space direction='horizontal' size={0} style={{width: '100vw',verticalAlign: 'bottom'}}>
          {this.getEntry(3)}
          {this.getEntry(4)}
        </Space>
      </Space>
    )
  }
  render() {
    return (
      <div >
        {this.getBody()}
      </div>
    );
  }
}

